export type CheckStatus =
  { type: 'idle' } | { type: 'valid' } | { type: 'invalid' };

export function ValidationStatusIcon({ status }: { status: CheckStatus }) {
  if (status.type === 'valid') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-riso-teal"
      >
        <path d="M20 6 9 17l-5-5" />
      </svg>
    );
  }

  if (status.type === 'invalid') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-destructive"
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    );
  }

  return null;
}
